import {Injectable} from '@angular/core';
import {NgbDateAdapter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class SbDateStructAdapter extends NgbDateAdapter<NgbDateStruct> {

  fromModel(date: NgbDateStruct | null): NgbDateStruct | null {
    return (date && this.isInteger(date.year) && this.isInteger(date.month) && this.isInteger(date.day)) ? {
      year: date.year,
      month: date.month,
      day: date.day
    } : null;
  }

  toModel(date: NgbDateStruct | null): NgbDateStruct | null {
    return (date && this.isInteger(date.year) && this.isInteger(date.month) && this.isInteger(date.day)) ? {
      year: date.year,
      month: date.month,
      day: date.day
    } : null;
  }

  isInteger(value: any): value is number {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  }
}
